export const notifications = {
  successDataUpdate: 'Veriler başarıyla değiştirildi.',
  errorOnDataUpdate: 'Veriler değiştirildiğinde, bir hata oluştu.',
  waitResponseIn24Hours: 'Davetinizin cevabını 72 saat içinde bekleyin.',
  workItemIsCanceled: 'Davet geri çekildi',
  notificationDeleted: 'Bildirim silindi',
  noNotifications: 'Hiçbir bildirimin yok',
  workInviteRejected: 'Davet reddedildi',
  workStartOnArtistArrivalConfirm:
    'İş, kulübün işyerindeki varlığınızı onayladığı andan itibaren başlayacak.',
  giveResponseFormWorkItem:
    'Davetiye 72 saat içinde bir cevap verin. 72 saat sonra davet silinecek.',
  generalError: 'Bir şeyler ters gitti, daha sonra deneyin.',
  passwordReseted: 'Parola düşürüldü',
  languageSwitched: 'Dil değişti',
  invitationExpired: 'Davetin süresi doldu',
  linkIsCopied: 'Bağlantı kopyalandı',
  accountIsVisible: 'Hesap aramada gösterilecek',
  hiringEnabled: 'Bir dizi sanatçı açık',
  hiringDisabled: 'Sanatçı seti kapalı',
  rejectedForReason: '__Var_0__ nedeniyle otclone',
  profileDeleted: 'Profil kaldırıldı',
  accountHiddenFromSearch:
    'Hesap gizli ve artık sanatçıların aramasında görüntülenmiyor',
  registerRequestSended: 'Kayıt talebi gönderildi',
  notFoundNotifications: 'Hiçbir bildirimin yok',
  lastWorkDaySeted: 'Son iş tarihi belirlendi'
};
